import { Box, Button, HStack, IconButton, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, VStack } from "@chakra-ui/react";
import { Close } from "@mui/icons-material";
import React from "react";
import apiClient from "../../clients/apiClient.js";


const DeleteGroupModal = ({ isModalOpen, onClose, groupToDelete, deleteGroup }) => {
    return (
        <Modal
            isOpen={isModalOpen}
            onClose={onClose}
            isCentered
            size="lg"
            motionPreset="slideInBottom"
        >
            <ModalOverlay
                bg="blackAlpha.300"
                backdropFilter="blur(1px)"
            />
            <GroupModal onClose={onClose} groupToDelete={groupToDelete} deleteGroupInTab={deleteGroup}/>
        </Modal>
    );
}

const GroupModal = ({ onClose, groupToDelete, deleteGroupInTab }) => {
    const [groupName, setGroupName] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [groupMembers, setGroupMembers] = React.useState([]);

    React.useEffect(() => {
        if (groupToDelete) {
            setGroupName(groupToDelete.name);
            setDescription(groupToDelete.description);
            setGroupMembers(groupToDelete.members);
        } else {
            setGroupName("");
            setDescription("");
            setGroupMembers([]);
        }
    }, [groupToDelete]);

    const deleteGroup = () => {
        apiClient.post('/account-settings/group-actions', {
            action: "delete_group",
            delete_group: {
                id: groupToDelete.id,
            }
        }).then(({data}) => {
            if (data?.success != true) {
                console.error("[DeleteGroupModal] Error deleting group", data?.message);
                return;
            }
            console.log("[DeleteGroupModal] Group deleted successfully", data);
            deleteGroupInTab({
                id: groupToDelete.id,
                name: groupName,
                description: description,
                members: groupMembers.map(member => ({
                    first_name: member.first_name,
                    last_name: member.last_name,
                    email: member.email
                })),
            })
            onClose();
        })
    }

    return (
        <ModalContent>
            <ModalHeader>
                <HStack
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                >
                    <Text
                        justifySelf={"flex-start"}
                        fontSize="xl"
                        fontWeight="bold"
                        fontFamily={"sans-serif"}
                        color={"#1d1d1d"}
                    >Delete Group</Text>
                    <IconButton
                        justifySelf={"flex-end"}
                        sx={{ 
                            paddingX:0, 
                            paddingY:0,
                            backgroundColor:"transparent",
                            "&:hover":{backgroundColor:"transparent"}
                        }}
                        icon={
                            <Close sx={{ padding:0, fontSize: 24, color: "#5d5d5d" }}/>
                        }
                        onClick={onClose}
                    />
                </HStack>
            </ModalHeader>
            <ModalBody>
                <VStack
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    width="100%"
                    spacing={0}
                >
                    <HStack
                        alignItems="center"
                        spacing={1}
                        marginBottom={"5px"}
                    >
                        <Text fontSize="14px" fontWeight={"semibold"} color="#1d1d1d" lineHeight={"22px"}>
                            Group Name
                        </Text>
                    </HStack>
                    <Box
                        mb="4"
                        w={"65%"}
                    >
                        <Text 
                            fontSize="16px"
                            fontWeight={"normal"}
                            color="#1d1d1d"
                            lineHeight={"22px"}
                            paddingX={"8px"}
                            paddingY={"4px"}    
                        > 
                            {groupName}
                        </Text>
                    </Box>
                    <Text mb="4px" fontSize="14px" fontWeight={"semibold"} color="#1d1d1d">
                        Description
                    </Text>
                    <Box
                        mb="4"
                        w={"90%"}
                    >
                        <Text 
                            fontSize="16px"
                            fontWeight={"normal"}
                            color="#1d1d1d"
                            lineHeight={"22px"}
                            paddingX={"8px"}
                            paddingY={"4px"}    
                        > 
                            {description}
                        </Text>
                    </Box>

                    {
                        groupMembers?.length > 0 && (
                            <Box mb="4" w={"100%"}>
                                <Text fontSize="14px" fontWeight={"semibold"} color="#1d1d1d">
                                    Members:
                                </Text>
                                <HStack wrap="wrap" spacing="4px" maxH={"200px"} overflowY={"scroll"} data-scrollable="true">
                                    {groupMembers.map((member, index) => (
                                        <Box
                                            key={index}
                                            p="2"
                                            border="1px solid #e5e5e5"
                                            borderRadius="4px"
                                            bg="#f9f9f9"
                                            display="flex"
                                            alignItems="center"
                                        >

                                            <VStack
                                                alignItems="flex-start"
                                                justifyContent="flex-start"
                                                width="100%"
                                                spacing={0}
                                            >
                                                <Text fontSize="14px" color="#1d1d1d">
                                                    {member.first_name} {member.last_name}
                                                </Text>
                                                <Text fontSize="12px" color="#7d7d7d">
                                                    {member.email}
                                                </Text>                                                
                                            </VStack>
                                        </Box>
                                    ))}
                                </HStack>
                            </Box>
                        )
                    }
                </VStack>
            </ModalBody>
            <ModalFooter>
                <Button
                    bgColor={"#E5E5E5"}
                    color={"#000"}
                    _hover={{ bgColor: "#E5E5E5" }}
                    onClick={onClose}
                    marginRight={"2px"}
                >
                    Discard
                </Button>
                <Button
                    bgColor={"#2584FD"}
                    color={"#fff"}
                    _hover={{ bgColor: "#2584FD" }}
                    onClick={deleteGroup}
                    marginLeft={"2px"}
                >
                    Delete Group
                </Button>
            </ModalFooter>
        </ModalContent>
    );
}


export default DeleteGroupModal;